module.exports = __webpack_public_path__ + "static/img/tzsm_banner.7588b2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tzsm_banner.png
// module id = v5PH
// module chunks = 21